import { Helper } from "../../core/util/helper";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { Config } from "../../core/config/config";
import { ComponentHelper } from "../../core/util/componentHelper";
import { TextBox } from "../../core/components/textBox";
import { CheckBox } from "../../core/components/checkBox";
import { DropDownList } from "../../core/components/dropDownList";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { IconsComboBox } from "../../core/components/iconComboBox";
import { DashboardStatistic } from "../../generalSettings/dashboard";
import React from "react"
import ReactDOM from "react-dom"

export const editDashboardStatistic = (dashboardStatistic: DashboardStatistic, title: string, custom: boolean) => {
    return new Promise<DashboardStatistic>((resolve) => {
        const targetElement = $("<div>");
        $("body").append(targetElement);
        const root = ReactDOM["createRoot"](targetElement[0]);


        const removeDialog = () => {
            root.unmount(targetElement[0]);
            targetElement[0].remove();
        }

        const onOk = (dashboardStatistic: DashboardStatistic) => {
            removeDialog();
            resolve(dashboardStatistic)
        }

        const onCancel = () => {
            removeDialog();
            resolve(null)
        }
        root.render(<DashboardEditDialog onOk={onOk} dashboardStatistic={dashboardStatistic} dialogTitle={title} onCancel={onCancel} custom={custom} />);
    });
}
interface DashboardEditDialogProps {
    onOk: (statistic: DashboardStatistic) => void;
    onCancel: () => void;
    dashboardStatistic: DashboardStatistic;
    dialogTitle: string;
    custom: boolean;
}
interface DashboardEditDialogState extends DashboardStatistic { }
class DashboardEditDialog extends React.Component<DashboardEditDialogProps, DashboardEditDialogState>{
    private factory = ComponentHelper.createFactory();
    private dialogProps: DialogProps = {
        title: "",
        open: true,
        actions: [
            {
                label: Config.translations.cancel,
                action: this.props.onCancel
            },
            {
                label: Config.translations.ok,
                action: () => {
                    if (Helper.isNullOrEmpty(this.state.Icon)) {
                        NotificationHelper.showWarningMessage(Helper.getTranslation("WebSMS.UserSettings.Dashboard.MissingIcon"));
                        return false;
                    }
                    if (Helper.isNullOrEmpty(this.state.TabName)) {
                        NotificationHelper.showWarningMessage(Helper.getTranslation("WebSMS.UserSettings.Dashboard.MissingName"));
                        return false;
                    }
                    const result: DashboardStatistic = {
                        Icon: this.state.Icon,
                        Id: this.state.Id,
                        TabName: this.state.TabName,
                        Permission: this.state.Permission,
                        Pos: this.state.Pos,
                        StatisticId: this.state.StatisticId
                    };
                    this.props.onOk(result)

                },
                primary: true
            }
        ],
        afterClose: () => {
        },
        width: 750
    };

    constructor(props: DashboardEditDialogProps) {
        super(props)
        this.state = {
            Icon: props.dashboardStatistic.Icon,
            TabName: props.dashboardStatistic.TabName,
            Id: props.dashboardStatistic.Id,
            Permission: props.dashboardStatistic.Permission,
            Pos: props.dashboardStatistic.Pos,
            StatisticId: props.dashboardStatistic.StatisticId
        };
    }

    private renderIconTextBox = () => {

        const row = this.props.custom && !Config.settings.allowDashboardNameChange ? 1 : 2;
        const gridRow = `${row}/${row + 1}`;

        return (
            <>
                <div style={{ display: "flex", alignItems: "center", gridColumn: "1/2", gridRow: gridRow }}>
                    {Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Icon.Icon")}
                </div>
                <div style={{ display: "flex", alignItems: "center", gridColumn: "2/3", gridRow: gridRow }}>
                    <IconsComboBox value={this.state.Icon} onChange={(value) => { this.setState({ Icon: value }) }} />
                </div>
                <div style={{ display: "flex", alignItems: "center", gridColumn: "3/4", gridRow: gridRow }}>
                    <i className={`fa-light fa-${this.state.Icon} fa-2x`} style={{ marginLeft: "10px" }} ></i>
                </div>
            </>
        );
    }

    private renderTabNameTextBox = () => {
        if (this.props.custom && !Config.settings.allowDashboardNameChange) {
            return <></>;
        }


        const props = this.factory.getDefaultTextBoxProps();
        props.value = this.state.TabName;
        props.field.triggerOnChange = true;
        props.onChange = (_, value: string) => {
            this.setState({ TabName: value })
        }
        props.disabled = this.props.custom && !Config.settings.allowDashboardNameChange;

        return (
            <>
                <div style={{ display: "flex", alignItems: "center", gridColumn: "1/2", gridRow: "1/2" }}>
                    {Helper.getTranslation("WebSMS.UserSettings.Dashboard.TabName") + (this.props.custom ? "" : " (" + Helper.getTranslation("WebSMS.UserSettings.Dashboard.TranslationKey") + ")")}
                </div>
                <div style={{ display: "flex", alignItems: "center", gridColumn: "2/3", gridRow: "1/2" }}>
                    <TextBox {...props} />
                </div>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gridColumn: "3/4", gridRow: "1/2", marginLeft: "10px" }} title={Helper.getTranslation(this.state.TabName)}>
                    <label style={{ flex: 1, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} >{Helper.getTranslation(this.state.TabName)}</label>
                </div>
            </>
        );
    }

    private renderPermissionDropDown = () => {
        const props = this.factory.getDefaultDropDownProps();
        props.value = this.state.Permission;
        props.dataSource = [0, 1, 2].map((right) => {
            return {
                text: Helper.getTranslation(`WebSMS.UserSettings.StandardRights.${right}`),
                value: right
            }
        });
        props.field.optionLabel = "";
        props.field.dataTextField = "text";
        props.field.dataValueField = "value";
        props.onChange = (_, value: number) => {
            this.setState({ Permission: value })
        }

        const row = this.props.custom && !Config.settings.allowDashboardNameChange ? 2 : 3;
        const gridRow = `${row}/${row + 1}`;

        return (
            <>
                <div style={{ display: "flex", alignItems: "center", gridColumn: "1/2", gridRow: gridRow }}>
                    {Helper.getTranslation("Dokument.Permission.Permission")}
                </div>
                <div style={{ display: "flex", alignItems: "center", gridColumn: "2/3", gridRow: gridRow }}>
                    <DropDownList {...props} />
                </div>
            </>
        );
    }

    private renderPermissionCheckBox = () => {
        const props = this.factory.getDefaultCheckBoxProps();
        props.value = this.state.Permission == 0 ? false : true;
        props.onChange = (_, value: boolean) => {
            this.setState({ Permission: value ? 1 : 0 })
        }

        const row = this.props.custom && !Config.settings.allowDashboardNameChange ? 2 : 3;
        const gridRow = `${row}/${row + 1}`;

        return (
            <>
                <div style={{ display: "flex", alignItems: "center", gridColumn: "1/2", gridRow: gridRow }}>
                    {Helper.getTranslation("WebCRM.EditIndividualCategories.Visible")}
                </div>
                <div style={{ display: "flex", alignItems: "center", gridColumn: "2/3", gridRow: gridRow }}>
                    <CheckBox {...props} />
                </div>
            </>
        );
    }

    render() {
        return (
            <>
                <Dialog {...this.dialogProps} title={this.props.dialogTitle} >
                    <div style={{ display: "grid", gridTemplateRows: `repeat(${Config.settings.allowDashboardNameChange ? 3 : 2}, 50px)`, gridTemplateColumns: "2fr 3fr 2fr" }} >
                        {this.renderTabNameTextBox()}
                        {this.renderIconTextBox()}
                        {this.props.custom ? this.renderPermissionCheckBox() : this.renderPermissionDropDown()}
                    </div>
                </Dialog >
            </>
        );
    }
}